// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import GRCollectibleBetslipDetailsCardContainer from '../../koh-lanta/containers/KLOrientationStepDetailsCardContainer';
import { type GRChipStatus } from '../types/chip';

const StyledDetailsCard = styled(GRCollectibleBetslipDetailsCardContainer)`
  max-height: 34%;
  overflow: scroll;
`;

type GRChipDetailsProps = {
  betslipReference?: string;
  status: GRChipStatus;
};

const GRChipDetails = ({ betslipReference, status }: GRChipDetailsProps) => {
  return betslipReference ? <StyledDetailsCard betslipReference={betslipReference} status={status} /> : null;
};

export default GRChipDetails;
